document.addEventListener("DOMContentLoaded", function () {
    document.querySelector(".add-to-bag").addEventListener("click", function (event) {
        event.preventDefault();
        const cartUrl = "/cart/add.js";
        const productId = document.querySelector(".add-to-bag").getAttribute("data-variant-id");
        const productQuantity = document.querySelector("input[name='quantity']").value;
        const addCartSpinner = document.querySelector(".product-hero .product-hero-right .add-to-cart div button.add-to-bag .add-cart-spinner");
        const addToBagText = document.querySelector(".product-hero .product-hero-right .add-to-cart div button.add-to-bag p");
        addCartSpinner.style.display = "flex";
        addToBagText.style.display = "none";
        $.ajax({
            url: cartUrl,
            type: "POST",
            data: { id: productId, quantity: productQuantity },
            success: function (success) {
                addCartSpinner.style.display = "none";
                addToBagText.style.display = "flex";
                document.querySelector(".mini-cart").style.display = "flex";
                $("#cart").load(" #cart");
            },
            error: function (error) {
                console.error("Error adding product to cart:", error);
            },
        });
    });

    document.querySelector(".mini-cart").addEventListener("click",function(event){
      if(event.target == document.querySelector(".mini-cart")){
          document.querySelector(".mini-cart").style.display = "none";
      }     
    })

    document.querySelector(".close-trigger").addEventListener("click",function(event){
      document.querySelector(".mini-cart").style.display = "none";    
    })
  
    document.querySelector(".direct-checkout").addEventListener("click", function (event) {
        event.preventDefault();
        const cartUrl = "/cart/add.js";
        const productId = document.querySelector(".add-to-bag").getAttribute("data-variant-id");
        const productQuantity = document.querySelector("input[name='quantity']").value;
        $.ajax({
            url: cartUrl,
            type: "POST",
            data: { id: productId, quantity: productQuantity },
            success: function (success) {
                window.location.href = "/checkout";
            },
            error: function (error) {
                console.error("Error adding product to cart:", error);
            },
        });
    });

    document.querySelector(".add-quantity").addEventListener("click", function () {
      const productQuantity = document.querySelector("input[name='quantity']").value;
      if(productQuantity >= 1) {
        document.querySelector("input[name='quantity']").value = parseInt(productQuantity) + 1;
      }      
    })
    
    document.querySelector(".remove-quantity").addEventListener("click", function () {
      const productQuantity = document.querySelector("input[name='quantity']").value;
      if(productQuantity > 1) {
        document.querySelector("input[name='quantity']").value = parseInt(productQuantity) - 1;
      }
    })
});